import './styles.scss'

import React from 'react'
import { useValues, useActions } from 'kea'
import ReactHtmlParser from 'react-html-parser'

import Img from 'lib/tags/img'
import I18n from 'lib/i18n'

import logic from './logic'

const PORTAL_GRID_ITEMS = [
  {
    imageSource: 'owl-glass',
    title: 'find_title',
    text: 'find_text'
  },
  {
    imageSource: 'owl-message',
    title: 'communicate_title',
    text: 'communicate_text'
  },
  {
    imageSource: 'owl-calendar',
    title: 'book_title',
    text: 'book_text'
  }
]

const PortalContent = React.forwardRef((props, ref) => {
  const { howItWorksLink } = useValues(logic)
  const { hideHow } = useActions(logic)

  const handleClose = event => {
    event.preventDefault()
    hideHow()
  }

  return (
    <div id='homepage-how' ref={ref}>
      <a className='close' href='#' onClick={handleClose}>
        <Img src='/homepage/close.webp' alt='close' />
      </a>
      <div className='grid'>
        <div className='col-1-1'>
          <h1>{I18n.t('react.homepage.how.title')}</h1>
        </div>
      </div>
      <div className='grid-768 small-wide'>
        {PORTAL_GRID_ITEMS.map((item, index) => (
          <div key={index} className='col-1-3'>
            <Img className='owl' src={`/homepage/${item.imageSource}.webp`} alt={item.imageSource} />
            <h2>{I18n.t(`react.homepage.how.${item.title}`)}</h2>
            <p>{I18n.t(`react.homepage.how.${item.text}`)}</p>
          </div>
        ))}
      </div>
      <div className='grid'>
        <div className='col-1-1'>
          <small>{ReactHtmlParser(I18n.t('react.homepage.how.small_print_with_url', { url: howItWorksLink }))}</small>
        </div>
      </div>
    </div>
  )
})

PortalContent.displayName = 'PortalContent'

export default PortalContent
